import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
// import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { GrFormPrevious } from "react-icons/gr";
import "../css/pagination.css";
import { MdOutlineNavigateNext } from "react-icons/md";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils";

const PER_PAGE = 25;
const UsersViaLink = () => {
  const [business, setBusinesslUser] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);

  // API'S MakeDeletionApproved Starts
  const getReviewables = () => {
    const data = {
      id: userData?._id,
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/via-link-users",
      data: data,
    };

    axios(config)
      .then(function (response) {
        setBusinesslUser(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error, "error Delete User");
        setBusinesslUser([])
      });
  };


  useEffect(() => {
    setLoading(true);
    getReviewables();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  //Remaning Days functions
  // function addDays(date, days) {
  //   var result = new Date(date);
  //   result.setDate(result.getDate() + days);
  //   return result;
  // }

  const calculate_Days = (created_date) => {
    const createdDate = new Date(created_date);
    const month = ["Jan","Feb","March","April","May","June","July","August","September","October","November","December"];
    const date = createdDate.getDate() + " " + month[createdDate.getMonth()] + ", " + createdDate.getHours() + ":" + createdDate.getMinutes();
    return date;
  };

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData =
    business.length === 0
      ? null
      : business.slice(offset, offset + PER_PAGE).map((user, index) => (
          <tbody key={index}>
            <tr>
              <td
                onClick={() => navigate(`/profile/${user?._id}/${slugify(user?.fname)}`, { state: { item: user._id } })}
                style={{cursor:"pointer"}}
              >
                <div className="d-flex px-2 py-1">
                  <div>
                    <img
                      src={ user.profile_pic ? user.profile_pic : "/img/upload-photo.png" }
                      className="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div>
                  <div className="d-flex flex-column justify-content-center">
                    <h6 className="mb-0 text-sm text-capitalize ">
                      {user?.fname}
                    </h6>
                    <p className="text-xs text-secondary mb-0">{user.email}</p>
                  </div>
                </div>
              </td>

              <td>
                <p className="align-middle ">{user?.business_info?.business_owner}</p>
              </td>

              <td>
                <p className="align-middle mb-n1">
                  {user.business_category ? user.business_category : "unknown"}
                </p>
              </td>

              <td>
                <p className="text-xs my-0">{calculate_Days(user.created_at)}</p>
              </td>

            </tr>
          </tbody>
        ));

  const pageCount = Math.ceil(business.length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>Business Users </h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                      {currentPageData !== null ?
                        <>
                          <thead>
                              <tr>
                                <th className="text-uppercase">User</th>
                                <th className="text-uppercase">Full Name</th>
                                <th className="text-uppercase">Category</th>
                                <th className="text-uppercase">Created Date</th>
                              </tr>
                          </thead>
                          {currentPageData}
                        </> :
                          <div className="d-flex justify-content-center w-100">
                              <p>No Accounts</p>
                          </div>
                        }
                      </table>
                    </div>

                    {business.length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UsersViaLink;